"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var payment_1 = __importDefault(require("payment"));

var regularExpressions_1 = require("./constants/regularExpressions");

var creditCards_1 = require("./constants/creditCards");

var changeRegexPattern = function changeRegexPattern(payment, issuer, regex) {
  var rules = payment.getCardArray().find(function (rulesObj) {
    return rulesObj.type === issuer;
  });
  payment.removeFromCardArray(issuer);
  payment.addToCardArray(Object.assign({}, rules, {
    pattern: regex
  }));
};

exports.fixCreditCardsPatterns = function (payment) {
  changeRegexPattern(payment, creditCards_1.cards.MAESTRO, regularExpressions_1.maestroPatternsRegex);
  changeRegexPattern(payment, creditCards_1.cards.VISA_ELECTRON, regularExpressions_1.visaElectronRegex);
  changeRegexPattern(payment, creditCards_1.cards.HIPERCARD, regularExpressions_1.hipercardPatternsRegex);
  var visaRules = payment.getCardArray().find(function (rulesObj) {
    return rulesObj.type === creditCards_1.cards.VISA;
  });
  payment.removeFromCardArray(creditCards_1.cards.VISA);
  payment.addToCardArray(visaRules);
  var cabalRules = payment.getCardArray().find(function (rulesObj) {
    return rulesObj.type === creditCards_1.cards.CABAL;
  });
  if (!cabalRules) payment.addToCardArray(creditCards_1.cabalRulesDefinition);
};

exports.getIssuer = function (value) {
  var payment = {};
  payment = payment_1.default;
  exports.fixCreditCardsPatterns(payment);
  return payment.fns.cardType(value);
};

var CREDIT_CARD_UTILS = {
  getIssuer: exports.getIssuer
};
exports.default = CREDIT_CARD_UTILS;